import { render, staticRenderFns } from "./PriceCategoryDiscountEdit.vue?vue&type=template&id=f30bd912&scoped=true"
import script from "./PriceCategoryDiscountEdit.vue?vue&type=script&lang=ts"
export * from "./PriceCategoryDiscountEdit.vue?vue&type=script&lang=ts"
import style0 from "./PriceCategoryDiscountEdit.vue?vue&type=style&index=0&id=f30bd912&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30bd912",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f30bd912')) {
      api.createRecord('f30bd912', component.options)
    } else {
      api.reload('f30bd912', component.options)
    }
    module.hot.accept("./PriceCategoryDiscountEdit.vue?vue&type=template&id=f30bd912&scoped=true", function () {
      api.rerender('f30bd912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/PriceCategoryDiscountEdit.vue"
export default component.exports